import React from "react";
import { Modal } from "react-bootstrap";
import "./Roullate_win_loss_modal.css";

function Roullate_win_loss_modal({
  show,
  onHide,
  isWin = true,
  winningNumber,
  winAmount,
  betTypeHigh = true,
  betTypeEven = true,
}) {
  const formattedWinAmount = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(winAmount);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="roulette-modal-dialog"
      contentClassName="roulette-modal-content"
      className="roulette-modal"
    >
      <Modal.Body>
        <div className="roulette-modal-wrapper">
          <div
            className={`roulette-modal-wrapper_hodler ${isWin ? "win_wrapper" : "loos_wrapper"
              }`}
          >
            {/* Header */}
            <div className="roulette-modal-header-custom">
              {isWin ? "🎉 You Win!" : "❌ You Lose"}
            </div>

            {/* Number Display */}
            <div className="roulette-modal-main-content">
              <div className="roulette-modal-number-box">{winningNumber}</div>
              <div className="roulette-modal-info">
                {betTypeHigh && <span>High</span>}
                {betTypeEven && <span>Even</span>}
              </div>
            </div>
          </div>

          {/* Footer (only when win) */}
          {isWin && (
            <div className="roulette-modal-footer-custom">
              {formattedWinAmount}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Roullate_win_loss_modal;
